export const GET_STARTED_ROUTES = {
  USER_TYPE: 'user-type',
  CONTACT: 'contact-info',
  FULLNAME: 'user-full-name',
  PASSWORD: 'password',
  LOCATION: 'location',
  SPONSORSHIP: 'sponsorship',
  SERVICES: 'services',
  RATE: 'rate',
  DETAILS: 'details',
  PLANS: 'plans',
  PAYMENT: 'payment',
  THANKYOU: 'thank-you',
}

export const DEFAULT_STEP = GET_STARTED_ROUTES.USER_TYPE

export const USER_TYPES = {
  PROVIDER: 'PROVIDER',
  SEEKER: 'SEEKER',
}

export const RATE_TYPES = {
  DAILY: 'daily_rate',
  HOURLY: 'hourly_rate',
}

export const ACTIONS = {
  UPDATE_USER_TYPE_FROM_QUERY: 'updateUserInputTypeFromQuery',
  UPDATE_USER_INPUT_FROM_DATA: 'updateUserInputFromData',
}

export const DEFAULT_USER_INPUT = {
  user_type: null,
  email: null,
  phone_number: null,
  first_name: null,
  last_name: null,
  password: null,
  origin: 'default',
}

export const DEFAULT_COUNTRY = {
  id: '4',
  name: 'Canada',
}
